export default __webpack_public_path__ + "f85485743d53e1e3b6b017e2a5e37ec1.svg";